import React, { useEffect, useRef, useState } from 'react';
import { API_BASE_URL } from '../helpers/config';
import NavBar from '../components/navbar';
import Footer from '../components/footer';
import NavRedes from '../components/navRedes';
export default function Contacto() {
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState(null);
  const request = useRef(null);
  useEffect(() => () => request.current?.abort(), []);

  async function send(event) {
    event.preventDefault();
    if (sending) return;
    const form = event.currentTarget;
    const values = Object.fromEntries(new FormData(form));
    request.current = new AbortController();
    setSending(true);
    setStatus(null);

    try {
      const response = await fetch(`${API_BASE_URL}/mail/send`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(values),
        signal: request.current.signal
      });
      if (!response.ok) throw new Error('Error');
      setStatus({
        success: true,
        text: '¡Gracias por escribirnos! Tu mensaje fue enviado.'
      });
      form.reset();
    } catch (error) {
      if (error.name !== 'AbortError') setStatus({
        success: false,
        text: 'No pudimos enviar el mensaje. Intentá nuevamente en unos minutos.'
      });
    } finally {
      if (!request.current.signal.aborted) setSending(false);
    }
  }

  return <><NavBar /><main id="contenido" className="page-shell contact-page"><div className="contact-intro"><span className="eyebrow">ABRAMOS LA CONVERSACIÓN</span><h1>Las buenas ideas<br />empiezan con<br /><em>un encuentro.</em></h1><p>Consultas, propuestas o simplemente unas palabras.<br />Nos gusta saber quién está del otro lado.</p><a className="contact-email" href="mailto:contacto.bocadesapo@gmail.com">contacto.bocadesapo@gmail.com ↗</a><NavRedes /></div><form className="contact-form" onSubmit={send}><h2>Escribinos.</h2><p>Los campos con * son obligatorios.</p><label htmlFor="contact-name">Tu nombre *</label><input id="contact-name" name="name" placeholder="¿Cómo te llamás?" autoComplete="name" maxLength={200} required /><label htmlFor="contact-email">Correo electrónico *</label><input id="contact-email" name="mail" type="email" placeholder="nombre@ejemplo.com" autoComplete="email" maxLength={254} required /><label htmlFor="contact-message">Tu mensaje *</label><textarea id="contact-message" name="text" placeholder="Te leemos…" rows={6} maxLength={10000} required /><button className="button button-dark" disabled={sending}>{sending ? 'Enviando…' : 'Enviar mensaje'} <span aria-hidden="true">↗</span></button>{status && <p className={`form-status ${status.success ? 'success' : ''}`} role={status.success ? 'status' : 'alert'}>{status.text}</p>}</form></main><Footer /></>;
}
